// extracted by mini-css-extract-plugin
module.exports = {"box":"accountRestrictionsSubForm_box__2A5ut"};